// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Preloader_backdrop__3J_TQ"};